'use client';

import { useMemo } from 'react';
import { useSequencingContext } from '@repo/sequencing/client/context/SequencingContext';
import { getSortedProductCardSections } from '@repo/sequencing/utils';
import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import type { Roundup } from '@repo/supergraph/roundup/base/types';
import type { MobileOrDesktop } from '@repo/utils/deviceType/types';
import { HYSAInlineFilterBar } from './HYSAInlineFilterBar';
import { HYSAProductsContent } from './HYSAProductsContent';

type Props = {
  productCardsSection: {
    categorySections: Roundup['productCardsSection']['categorySections'];
  };
  slug: string;
  pageUrl: string;
  initialLocation?: StateAbbreviation;
  isSeoBankingFFActive?: boolean;
  deviceType?: MobileOrDesktop;
  highestAPY?: number;
  hideFilterUI?: boolean;
};

export function HYSAProductsSection({
  productCardsSection,
  slug,
  pageUrl,
  initialLocation,
  isSeoBankingFFActive = false,
  deviceType,
  highestAPY,
  hideFilterUI = false,
}: Props) {
  const { sequence } = useSequencingContext();

  const sortedProductCardSections = useMemo(
    () => getSortedProductCardSections(productCardsSection, sequence.productCards),
    [sequence.productCards],
  );

  const content = (
    <HYSAProductsContent
      pageUrl={pageUrl}
      slug={slug}
      isSeoBankingFFActive={isSeoBankingFFActive}
      categorySections={sortedProductCardSections.categorySections}
      deviceType={deviceType}
      highestAPY={highestAPY}
    />
  );

  return (
    <section data-testid="products-container">
      {hideFilterUI ? (
        content
      ) : (
        <HYSAInlineFilterBar slug={slug} initialLocation={initialLocation}>
          {content}
        </HYSAInlineFilterBar>
      )}
    </section>
  );
}
